module.exports = __webpack_public_path__ + "img/circle-with-cross.e45c8978.svg";